// extracted by mini-css-extract-plugin
export default {"link":"kF-z","disabled":"lF-z"};